import { render, staticRenderFns } from "./ListUserMessages.vue?vue&type=template&id=1e8b3cd0&"
import script from "./ListUserMessages.vue?vue&type=script&lang=ts&"
export * from "./ListUserMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports